import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import * as S from "../styles";
import { getPlanUnitLabel } from "../../Cadastro/plans";

const formatBRL = value =>
  Number(value || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

const parseAmount = amountStr =>
  parseFloat(String(amountStr || "0").replace(/\./g, "").replace(",", "."));

const PlanDetailsModal = ({ open, onClose, formik, plans }) => {
  const coupom = useSelector(state => state.app.coupom);
  const isCouponValid = coupom?.is_valid;
  const currentPlan =
    plans.find(p => p.id === formik.values.plan?.id) || formik.values.plan;

  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = e => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  const displayName = isCouponValid
    ? coupom?.description || coupom?.name || currentPlan?.name
    : currentPlan?.name;

  const displayDescription = isCouponValid
    ? coupom?.subtitle ||
      coupom?.description ||
      `Oferta válida para contratação do ${currentPlan?.name}. Cobrança imediata.`
    : "Plataforma jurídica completa com cálculos, consultas e ferramentas para potencializar sua atuação.";

  const displayAmount = isCouponValid
    ? parseAmount(coupom?.amount)
    : parseAmount(currentPlan?.amount);

  const displayOldAmount = isCouponValid ? parseAmount(coupom?.old_amount) : 0;

  const unitLabel = getPlanUnitLabel(currentPlan?.type);

  return (
    <S.ModalOverlay open={open} onClick={onClose}>
      <S.ModalDialog
        role="dialog"
        aria-modal="true"
        aria-labelledby="plan-details-title"
        onClick={e => e.stopPropagation()}
      >
        <S.ModalClose onClick={onClose} aria-label="Fechar">×</S.ModalClose>
        <S.ModalContent>
          <S.ModalMain>
            <S.ModalBody>
              <h3 id="plan-details-title" className="modal-title">Detalhes do plano</h3>

              <p className="plan-name">{displayName}</p>
              <p className="desc">{displayDescription}</p>

              {displayOldAmount > 0 && displayOldAmount > displayAmount && (
                <p className="price-old">
                  {formatBRL(displayOldAmount)}
                  {unitLabel}
                </p>
              )}
              <p className="price">
                {formatBRL(displayAmount)}
                <small>{unitLabel}</small>
              </p>
            </S.ModalBody>
            <S.ModalFooter>
              <S.PrimaryButton type="button" onClick={onClose}>
                Confirmar plano
              </S.PrimaryButton>
            </S.ModalFooter>
          </S.ModalMain>

          <S.ModalAside>
            <img
              src="/media/logo-jusfy.svg"
              alt="Jusfy"
              className="aside-logo"
            />
            <h4 className="aside-headline">
              Tudo o que o seu escritório precisa em um só lugar.
            </h4>
            <p className="aside-sub">
              Mais de 50 mil advogados confiam na Jusfy para acelerar cálculos,
              petições e gestão de processos.
            </p>
            <ul className="aside-list">
              <li>
                <CheckCircleIcon />
                <span>Cálculos trabalhistas e revisionais ilimitados.</span>
              </li>
              <li>
                <CheckCircleIcon />
                <span>Petições geradas por IA em segundos.</span>
              </li>
              <li>
                <CheckCircleIcon />
                <span>Suporte humano e atualizações constantes.</span>
              </li>
            </ul>
            <p className="aside-trust">
              Pagamento seguro · Cancele quando quiser · Sem fidelidade.
            </p>
          </S.ModalAside>
        </S.ModalContent>
      </S.ModalDialog>
    </S.ModalOverlay>
  );
};

export default PlanDetailsModal;
